import { useMemo, useState } from 'react';
import { Tabs } from '../components/primitives';
import { detectPlatform } from '../lib/ideDownload';
import { AppleIcon, WindowsIcon } from './DownloadIcons';
import { MacDownloadPane } from './MacDownloadPane';
import { WinDownloadPane } from './WinDownloadPane';

type PlatformTab = 'mac' | 'win';

/**
 * Platform-tabbed IDE download surface. UA-detected default tab; manual click
 * overrides without URL change. Unknown UAs default to macOS.
 */
export function IdeDownloadPanel() {
  const initial = useMemo<PlatformTab>(() => {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const detected = detectPlatform(ua);
    return detected === 'win' ? 'win' : 'mac';
  }, []);
  const [active, setActive] = useState<PlatformTab>(initial);

  return (
    <div className="lp-download-tabs-wrap">
      <Tabs
        items={[
          {
            value: 'mac',
            label: (
              <>
                <AppleIcon className="lp-download-tab-icon" />
                macOS
              </>
            )
          },
          {
            value: 'win',
            label: (
              <>
                <WindowsIcon className="lp-download-tab-icon" />
                Windows
              </>
            )
          }
        ]}
        value={active}
        onChange={(v) => setActive(v as PlatformTab)}
        label="Platform downloads"
        dataTestId="lp-download-tab"
        className="lp-download-tabs lp-download-tabs-segmented"
      />
      <div
        role="tabpanel"
        aria-labelledby={`lp-download-tab-${active}`}
        className="lp-download-pane"
      >
        {active === 'mac' ? <MacDownloadPane /> : <WinDownloadPane />}
      </div>
    </div>
  );
}
